import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";

import { GetInfluencers, IInfluencer } from "@shared/lib/types/influencer";
import { BackednResponse } from "@shared/lib/types";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";
import { InfluencerService } from "../services/influencer.service";

export function useGetInfluencer(influencerId: string) {
  const { data, isLoading, isError, error, refetch } = useQuery<
    BackednResponse<IInfluencer>
  >({
    queryKey: [...INFLUENCER_LIST_QUERY_KEY, influencerId],
    queryFn: () => InfluencerService.getInfluencerById(influencerId),
    enabled: !!influencerId,
  });

  const errorMessage = isError && error?.message;

  if (errorMessage) {
    ToastService.error(errorMessage);
  }

  return {
    influencer: data?.data,
    isFetching: isLoading,
    isError,
    refetch,
  };
}
